import { adviceState } from '@/lib/store/advice.store';
import { observe } from '@legendapp/state';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export function useSyncChatUrlState(
  chatId: string | null,
  isInternalNavRef: React.MutableRefObject<boolean>
) {
  const router = useRouter();

  useEffect(() => {
    const dispose = observe(() => {
      const isTransitioning = adviceState.isTransitioning.get();
      const currentChatId = adviceState.currentChatId.get();
      if (!isTransitioning) {
        if (currentChatId !== chatId) {
          if (currentChatId) {
            isInternalNavRef.current = true;
            router.replace(`?chatId=${currentChatId}`, { scroll: false });
          } else if (!currentChatId && chatId) {
            isInternalNavRef.current = true;
            router.replace('/', { scroll: false });
          }
        }
      }
    });
    return () => dispose();
  }, [chatId, router, isInternalNavRef]);
}
